/***************************************
 CREATED BY : Vekanth
 Last Modified Date : 26/06/2018
**************************************/

import { Component, OnInit, Input, ViewChild, EventEmitter, Output, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { CupService } from '../../shared/services/cup.service';

import { IProviderSearch } from '../providersearch_model/providersearch.model';
import { IProvider } from '../providersearch_model/provider.model';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { IProviderDetails } from '../providersearch_model/providerdetails';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GridComponent } from '../../shared/grid/grid.component';
import { SecureStorageService } from '../../secure-storage.service';
import { of, forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
const GRID_MESSAGE = 'Please use \'Provider Search\' to find the required records';

@Component({
    selector: 'app-providersearch',
    templateUrl: './providersearch.component.html',
    styleUrls: ['./providersearch.component.css'],
    standalone: false
})
export class ProviderSearchComponent implements OnInit, OnDestroy, OnChanges {

  nsSubscription: any;
  @ViewChild('dist') geoDistance: any;
  @ViewChild('providerSearchGrid') providerSearchGrid: GridComponent;
  @Input() showProvider: boolean;
  @Input() showProviderMap: boolean;
  @Input() providerType: string;
  @Output() sendProviderDetails = new EventEmitter<boolean>();
  @Input() fromAuthScreens: boolean;
  public providerDetailsData: IProviderDetails;
  public providerData: IProvider;
  public providerDetailsColumns = [];
  public providerDetailsGridRow = [];
  public showView = false;
  public showViewForDetails = false;
  // public providerDetailGridTitle = 'CONTRACTS BY SPECIALITY AND ADDRESS FOR: IPA: CAREMORE LA-OC';
  public providerSearchGridTitle = 'PROVIDER LIST';
  public currentPath: any;
  public openedPanel = false;
  public gridRows: IProviderSearch[] = [];
  public recordsWithOutNS: IProviderSearch[] = [];
  public providerSearchGridColumns = [];
  public providerSearchForm: UntypedFormGroup;
  public distanceInMiles = {};
  private providerSearchError = false;
  private zipcodeSearchError = false;
  private showGrid: boolean;
  public ProviderSearchGridTitle = 'SEARCH RESULT';
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  public providerIdFormControl = new UntypedFormControl();
  public providerNameFormControl = new UntypedFormControl();
  public providerOfficeNameFormControl = new UntypedFormControl();
  public providerSpecialtyFormControl = new UntypedFormControl();
  public providerIPAFormControl = new UntypedFormControl();
  public providerZipCodeFormControl = new UntypedFormControl();
  public providerDistanceFormControl = new UntypedFormControl();
  public providerCityFormControl = new UntypedFormControl();
  public providerNeighborhoodFormControl = new UntypedFormControl();
  public loadProviderGridWithResults = false;
  public milesDistance: string;
  public IPADataList: any[];
  public SpecialityList: any[];
  public ZipCodeList: any[];
  public NeighborhoodList: any[];
  public selectedProviderFromGrid: any;

  public totalRecords = 1;
  public geoDistanceAny = 'any';
  public showMapViewHeader = true;
  public showMap = false;
  public selectedProviderAddress: string;
  public selectedProviderDestination: string;

  public searchCriteria: any = {};
  private subscription: any;
  private searchWithFilterSubscription: any;
  public isServerSidePagination = false;
  public pages = 1;
  public loadGridWithResults = false;

  // overAllSearch
  public overAllSearchSubscription: any;
  public isOverAllSearch = false;
  public nameFromOverAllSearch: any;
  public providerOverAllSearch: any;
  public messageFromOverAllSearch = false;
  public providerGridStatusText = GRID_MESSAGE;
  private providerGridSubscription: any;
  public nwstatus: boolean;
  public memberdetails: any;

  constructor(private cupService: CupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlconstantsService: UrlconstantsService,
    private fb: UntypedFormBuilder,
    private secureStorage:SecureStorageService) {
    // this.createProviderForm();
    this.currentPath = this.router.url;
    this.initProviderGridCol();
    this.subscripeInitiateSearch();
    this.overAllSearch();
    this.getRouteParams();
    this.memberdetails = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('memberDetails'));
  }

  public subscripeInitiateSearch() {
    this.subscription = this.cupService.initiateProviderSearch.subscribe(data => {
      this.loadProviderGridWithResults = data;
    });

    this.searchWithFilterSubscription = this.cupService.getProviderSearchData.subscribe(search => {
      if (this.loadProviderGridWithResults) {
        this.searchCriteria = search;
        this.providerGridStatusText = undefined;
        this.gridRows = [];
        this.totalRecords = 0;
        this.pages = 1;
        if (this.providerSearchGrid) {
          this.providerSearchGrid.resetGridData();
        }
        this.getProvidersData(1, 10, this.searchCriteria ? undefined : 'reset');
      } else {
        this.clearAll();
      }
    });
  }
  public getProvidersData(page, noOfRecords, soureCall?: string) {
    if (this.providerGridSubscription) {
      this.providerGridSubscription.unsubscribe();
    }
    try {
      this.cupService.isLoading(true);

      if (soureCall !== 'reset' && !this.showProvider) {
        if (JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerResults'))) {
          this.searchCriteria = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerResults'));
        }
      } else {
        sessionStorage.removeItem('providerResults');
        this.providerGridStatusText = GRID_MESSAGE;
      }
      const providerId = (this.searchCriteria && this.searchCriteria.providerId) ? this.searchCriteria.providerId : '';
      const name = (this.searchCriteria && this.searchCriteria.name) ? this.searchCriteria.name : '';
      const city = (this.searchCriteria && this.searchCriteria.city) ? this.searchCriteria.city : '';


      const speciality = (this.searchCriteria && this.searchCriteria.speciality) ? this.searchCriteria.speciality.id : '';
      const ipa = (this.searchCriteria && this.searchCriteria.ipa) ? this.searchCriteria.ipa.id : '';
      const neighborhood = (this.searchCriteria && this.searchCriteria.neighborhood) ? this.searchCriteria.neighborhood.id : '';
      const distance = (this.searchCriteria && this.searchCriteria.distance) ? this.searchCriteria.distance : 0;
      const zipCodeAndCity = (this.searchCriteria && this.searchCriteria.zipCodeAndCity) ? this.searchCriteria.zipCodeAndCity : '';
      const provType = this.providerType ? this.providerType : '';

      const providerSearchObj = {
        providerId: providerId,
        name: name,
        specialty: speciality,
        region: ipa,
        zipCode: zipCodeAndCity,
        distance: distance,
        neighborhood: neighborhood,
        provType: provType,
        page: '',
        size: ''
      };

      const providerUrl = this.urlConstant.providerSearch;
      const providerFilterData = JSON.stringify(providerSearchObj);
      this.providerGridSubscription = this.cupService.retrieveData('post', providerUrl, providerFilterData).subscribe(data => {
        try {
          if (data != null && data.total !== 0 && data.records != null && data.records.length > 0) {
            this.totalRecords = data.total;
            this.pages = Math.ceil(this.totalRecords / noOfRecords);
            const providers: any = [];
            const providerList: IProvider[] = data.records;
            if (data.records.length === 1) {
              if (this.isOverAllSearch) {
                this.cupService.isOverallSearchResultSingle(true);
                this.router.navigate(['/home/provider/provider-details/', data.records[0].id, true]);
              } else {
                this.cupService.isOverallSearchResultSingle(false);
              }
            }
            providerList.forEach(function (providerDetailsList) {
              const ps: any = [];
              const ss: any = [];
              if (providerDetailsList.speciality) {
                providerDetailsList.speciality.forEach(function (providerDetailsList) {
                  if (providerDetailsList.primary === true) {
                    ps.push(providerDetailsList.description);
                  } else {
                    ss.push(providerDetailsList.description);
                  }
                });
              }
              const primarySpecialty: string = ps.join(', ');
              const secondarySpecialty: string = ss.join(', ');
              let address: string = providerDetailsList.contract[0].address.address1;
              if (providerDetailsList.contract[0].address.address2) {
                address += providerDetailsList.contract[0].address.address2;
              }
              const specialityUid =
                (providerDetailsList.speciality && providerDetailsList.speciality.length > 0) ?
                  providerDetailsList.speciality[0].id : null;
              const p: IProviderSearch = {
                rowNum: providerDetailsList.rowNum,
                id: providerDetailsList.id,
                name: providerDetailsList.name,
                specialty: primarySpecialty,
                subSpecialty: secondarySpecialty,
                addressid: providerDetailsList.contract[0].address.id,
                specialityUid: specialityUid,
                genericSpecialityUid: providerDetailsList.specialtyUid,
                address: address,
                city: providerDetailsList.contract[0].address.city,
                map: '',
                phone: providerDetailsList.contract[0].address.phone,
                status: providerDetailsList.contract[0].parStatus,
                neighborhood: providerDetailsList.contract[0].neighborhood,
                region: providerDetailsList.contract[0].region,
                providerId: providerDetailsList.providerId,
                providerContractUid: providerDetailsList.contract[0].address.id,
                distance: providerDetailsList.distance === 0 ?
                  '' : providerDetailsList.distance + 'miles'
              };
              providers.push(p);
            });

            if (this.nwstatus) {
              this.recordsWithOutNS = providers;
              if (this.recordsWithOutNS && this.recordsWithOutNS.length > 0) {
                // let newData=this.recordsWithOutNS.slice(1, 10);
                this.updateNetworkStatus(0, 10);
              }
            }
            this.gridRows = providers;

            // this.cupService.isLoading(false);
            this.messageFromOverAllSearch = false;
          } else {
            if ((this.isOverAllSearch || this.providerOverAllSearch) && this.searchCriteria) {
              this.messageFromOverAllSearch = true;
            }
            this.totalRecords = 0;
            this.pages = 1;
            this.gridRows = [];
            // this.cupService.isLoading(false);
          }
          this.cupService.isLoading(false);
          this.providerGridStatusText = '';
          if (this.isOverAllSearch || this.providerOverAllSearch) {
            this.cupService.overAllSearchClearName(true);
          }
        } catch (ex) {
          //console.error(ex);
          this.cupService.isLoading(false);
        }
      }, error => {
        this.cupService.isLoading(false);
      });
    } catch (ex) {
      this.cupService.isLoading(false);
    }
  }

  public updateNetworkStatus(startIndex, length) {
    // edh call
    // if(!startIndex && !totalCount) {
    //   startIndex = 0;
    //   totalCount = 10;
    // }
    if (this.nsSubscription) {
      this.nsSubscription.unsubscribe();
    }
    const currentPageRecords = this.recordsWithOutNS.slice(startIndex, length);
    const memberPlanId = this.memberdetails.planId;
    const providerForNS: Observable<any>[] = [];

    if (currentPageRecords && currentPageRecords.length > 0 && Array.isArray(currentPageRecords)) {
      currentPageRecords.forEach(provider => {
        if (!(<any>provider).nwstatus) {
          const url = this.urlConstant.networkStatus + '?planid=' + memberPlanId + '&providerid=' + provider.providerId;
          // this.cupService.isShowSpinner(true);
          const netWorkStatusCall = this.cupService.retrieveData('get', url).pipe(map(networkStatus => {
            const selectedProvider = this.recordsWithOutNS.find(x => x.rowNum === provider.rowNum);
            if (selectedProvider) {
              (<any>selectedProvider).nwstatus = networkStatus.providerNetworkStatus;
            }
            this.gridRows = this.cupService.deepCopy(this.recordsWithOutNS);
            this.totalRecords = this.gridRows.length;
            // this.cupService.isShowSpinner(false);
          }, error => {
            return of(null);
            // this.cupService.isShowSpinner(false);
          }));
          providerForNS.push(netWorkStatusCall);
        }
      });
    }

    // this.gridRows = [];
    // this.totalRecords = 0;
    // this.pages = 1;
    if (providerForNS && providerForNS.length > 0) {
      this.cupService.isShowSpinner(true);
      this.nsSubscription = forkJoin(providerForNS).subscribe(x => {
        this.cupService.isShowSpinner(false);
        // for(var i = startIndex, j = 0; i < length; i++, j++){
        //   this.recordsWithOutNS[i] = currentPageRecords[j];
        // }

        // this.gridRows = this.cupService.deepCopy(this.recordsWithOutNS);
        // this.totalRecords = this.gridRows.length;
      });

    }

  }

  /*Page change event*/
  public onPageChanged(pageChangedObj) {
    if (this.nwstatus) {
      if (pageChangedObj) {

        if (this.gridRows && this.gridRows.length > 0) {
          // let newData=this.gridRows.slice(pageChangedObj.nextRecordStart, pageChangedObj.nextRecordStart + this.providerSearchGrid.rowPerPage);
        }

        if (pageChangedObj.recordsPerPage > 10) {
          pageChangedObj.recordsPerPage = pageChangedObj.recordsPerPage - 10;
        } else {
          pageChangedObj.recordsPerPage = '';
        }
        this.updateNetworkStatus(pageChangedObj.nextRecordStart,
          pageChangedObj.nextRecordStart + this.providerSearchGrid.rowPerPage + pageChangedObj.recordsPerPage);
      } else { // First time
        this.updateNetworkStatus(pageChangedObj.nextRecordStart, pageChangedObj.recordsPerPage);
      }
    } else {
      this.getProvidersData(pageChangedObj.page, pageChangedObj.event.rows);
    }
  }
  /* Clearch Search */
  private clearAll() {
    if (this.providerGridSubscription) {
      this.providerGridSubscription.unsubscribe();
    }
    this.loadGridWithResults = false;
    this.searchCriteria = undefined;
    sessionStorage.removeItem('providerResults');
    this.totalRecords = 0;
    this.gridRows = [];
    this.pages = 1;
    if (this.providerSearchGrid) {
      this.providerSearchGrid.resetGridData();
    }
    this.cupService.isLoading(false);
    this.providerGridStatusText = GRID_MESSAGE;
    this.cupService.isRefineSearchClearAll(false);
    this.cupService.overAllSearchClearName(true);
    this.messageFromOverAllSearch = false;
  }

  /**Toggle Accordion */
  public toggleAccordion() {
    this.openedPanel = this.openedPanel ? false : true;
  }
  /*Form Validation*/
  public formValidation() {
    const validName = /^[A-Za-z]+$/;
    this.providerNameFormControl = new UntypedFormControl('', Validators.pattern(validName));
  }
  /* Check for the GeoDistance*/
  public checkGeoDistance() {
    if (this.milesDistance && this.providerZipCodeFormControl.value == null) {
      this.zipcodeSearchError = true;
    } else {
      this.zipcodeSearchError = false;
    }
  }

  /*Create Form*/
  private createProviderForm() {
    this.providerSearchForm = this.fb.group({
      providerNameFormControl: this.providerNameFormControl,
      providerOfficeNameFormControl: this.providerOfficeNameFormControl,
      providerSpecialtyFormControl: this.providerSpecialtyFormControl,
      providerIPAFormControl: this.providerIPAFormControl,
      providerZipCodeFormControl: this.providerZipCodeFormControl,
      providerDistanceFormControl: this.providerDistanceFormControl,
      providerCityFormControl: this.providerCityFormControl,
      providerNeighborhoodFormControl: this.providerNeighborhoodFormControl,
    });
  }
  /*Grid Inputs*/
  private initProviderGridCol() {
    this.providerSearchGridColumns = [
      { style: { 'width': '25px' } },
      { field: 'name', header: 'NAME', style: { 'width': '105px' }, sortable: 'true' },
      {
        field: 'specialty',
        fieldType: 'specialtyData',
        header: 'PRIMARY SPECIALTY',
        style: { 'width': '160px', 'word-wrap': 'break-word' }, sortable: 'true'
      },
      {
        field: 'subSpecialty',
        fieldType: 'specialtyData',
        header: 'SECONDARY  SPECIALTY',
        style: { 'width': '160px', 'word-wrap': 'break-word' }, sortable: 'true'
      },
      { field: 'address', header: 'ADDRESS', style: { 'width': '100px' }, sortable: 'true' },
      { field: 'city', header: 'CITY', style: { 'width': '60px' }, sortable: 'true' },
      { field: 'phone', header: 'PHONE', style: { 'width': '60px' }, sortable: 'true' },
      { field: 'status', header: 'STATUS', style: { 'width': '75px' }, sortable: 'true' },
      { field: 'region', header: 'REGION', style: { 'width': '120px' }, sortable: 'true' },
      { field: 'neighborhood', header: 'NEIGHBORHOOD', style: { 'width': '120px' }, sortable: 'true' },
    ];
  }

  /*Submit Form*/
  private searchproviderData(formValues) {
    if ((this.providerNameFormControl.value === '' || this.providerNameFormControl.value == null)
      && (this.providerOfficeNameFormControl.value === '' || this.providerOfficeNameFormControl.value == null)
      && (this.providerSpecialtyFormControl.value === '' || this.providerSpecialtyFormControl.value == null)) {
      this.gridRows = [];
      this.providerSearchError = true;
    } else {
      this.providerSearchError = false;
      if (this.providerNameFormControl.status === 'VALID'
        && this.providerSpecialtyFormControl.status === 'VALID' && !this.zipcodeSearchError) {
        const providerId = this.providerIdFormControl.value ? this.providerIdFormControl.value : '';
        const name = this.providerNameFormControl.value ? this.providerNameFormControl.value : '';
        const city = this.providerCityFormControl.value ? this.providerCityFormControl.value : '';
        const speciality = this.providerSpecialtyFormControl.value ? this.providerSpecialtyFormControl.value : '';
        const ipa = this.providerIPAFormControl.value ? this.providerIPAFormControl.value : '';
        const neighborhood = this.providerNeighborhoodFormControl.value ? this.providerNeighborhoodFormControl.value : '';
        const distance = this.providerDistanceFormControl.value ? this.providerDistanceFormControl.value : 0;
        const zipCodeAndCity = this.providerZipCodeFormControl.value ? this.providerZipCodeFormControl.value : '';

        const providerSearchObj = {
          providerId: providerId,
          name: name,
          specialty: speciality,
          city: city,
          region: ipa,
          zipCode: zipCodeAndCity,
          distance: distance,
          neighborhood: neighborhood
        };

        const providerUrl = this.urlConstant.providerSearch;
        this.cupService.retrieveData('post', providerUrl, providerSearchObj).subscribe(data => {
          if (data) {
            this.totalRecords = data.total;
          }
          this.gridRows = data.records;
          this.showGrid = true;
        });
      }
    }
  }

  /*Clear Search*/
  public clearSearch() {
    this.createProviderForm();
    this.providerSearchError = false;
    this.zipcodeSearchError = false;
    this.providerSearchForm.reset();
    this.providerGridStatusText = GRID_MESSAGE;
    this.showGrid = false;
  }

  public eventOutput(event) {
    this.selectedProviderFromGrid = event;
    this.sendProviderDetails.emit(event);
    const url = this.urlConstant.providerDetails.replace('{providerid}', event.id);
    this.cupService.retrieveData('get', url).subscribe(data => {
      if (data != null) {
        this.providerDetailsData = data;
        this.providerDetailsData.internalId = data.group + '-' + data.providerId;
        this.providerDetailsGridRow = data.providerContracts;
      }
      // this.providerDetailsGridRow = data;
      // document.getElementById('openModalButton') ? document.getElementById('openModalButton').click() : '';
    });

  }
  public mapOutput(event) {

    this.showMap = true;
    this.selectedProviderAddress = event.address + ' ' + event.city;
    document.getElementById('openMapModal').click();
  }
  public overAllSearch() {
    this.overAllSearchSubscription = this.cupService.overAllSearch.subscribe(data => {
      this.isOverAllSearch = data;
    });
  }

  private getRouteParams() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.nameFromOverAllSearch = params['name'];
      this.providerOverAllSearch = params['over-all'];
      if (this.providerOverAllSearch) {
        this.searchCriteria.name = this.providerOverAllSearch === 'true' ? this.nameFromOverAllSearch : this.searchCriteria.name;
        this.getProvidersData(1, 10, undefined);
      }
    });
  }
  ngOnInit() {
    if (JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerResults'))) {
      this.getProvidersData(1, 10);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.fromAuthScreens) {
      this.nwstatus = true;
      this.providerSearchGridColumns.push({ field: 'distance', header: 'DISTANCE', style: { 'width': '80px' }, sortable: 'true' });
      this.providerSearchGridColumns.push({ field: 'nwstatus', header: 'N/W STATUS', style: { 'width': '90px' }, sortable: 'true' });
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.searchWithFilterSubscription.unsubscribe();
    this.overAllSearchSubscription.unsubscribe();
  }
}
